

export type Section = {
  sectionName: string;
  sectionLabel: string;
  fields: Array<Field>;
}

export type Field = {
  id: string;
  fieldLabel: string;
}

export const fields = {
  catchment: [{
    sectionName: "Human Resources",
    fields: []      
  },
  {

  }]
}


export const catchmentHeaders: Array<any> = [
  {
    value: 'label',
    text: 'Human Resources',
  },
  {
    value: 'quantity',
    text: 'Quantity'
  },
  {
    value: 'perDiem',
    text: 'Per Diem and Travel Allowances'
  }
]


export const exampleCatchmentItems: Array<any> = [
  {
    id: 'number_microplan_teams',
    perDiem: 'TBD',
    quantity: 'TBD',
    label: 'Number of Microplan Teams'
  },
  {
    id: 'number_vaccinators',
    perDiem: 'TBD',
    quantity: 'TBD',
    label: 'Number of vaccinators'
  },
  {
    id: 'number_supporting_vaccinators',
    perDiem: 'TBD',
    quantity: 'TBD',
    label: 'Number of staff supporting vaccinators (traveling)'
  },
  {
    id: 'number_support_staff_base',
    perDiem: 'TBD',
    quantity: 'TBD',
    label: 'Number of support staff (at base)'
  },
  {
    id: 'number_of_supervisors_base',
    perDiem: 'TBD',
    quantity: 'TBD',
    label: 'Number of supervisors (at base)'
  },
  {
    id: 'per_diem_travel',
    perDiem: 'TBD',
    quantity: 'TBD',
    label: 'Per diem and travel allowances'
  },
]

export const exampleCatchmentSupplyHeaders: Array<any> = [
  {
    value: 'label',
    text: 'Supplies',
  },
  {
    value: 'quantity',
    text: 'Quantity'
  },
  {
    value: 'cost',
    text: 'Cost'
  },
  {
    value: 'cubicCentimeters',
    text: 'Cubic CM'
  }
]

export const exampleCatchmentSupplyItems: Array<any> = [
  {
    id: 'vaccine_doses',
    label: 'Vaccine doses',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'diluent',
    label: 'Diluent',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'administration_syringes',
    label: 'Administration syringes',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'dilution_syringes',
    label: 'Dilution syringes',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'saftey_boxes',
    label: 'Safety boxes',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'ice_packs',
    label: 'Ice packs',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'vaccine_carriers',
    label: 'Vaccine carriers',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: '20l_cold_boxes',
    label: '20L cold boxes (at base)',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'aefi_treatment_kits',
    label: 'AEFI treatment kits',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'finger_marking_pens',
    label: 'Finger marking pens',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'covid_100ml_hand_sanitizer',
    label: 'COVID-19: 100mL bottles of hand sanitizer',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  },
  {
    id: 'covd_n95_masks',
    label: 'COVID-19: N-95 masks',
    quantity: 'TBD',
    cost: 'TBD',
    cubicCentimeters: 'TBD'
  }
]



export const microplanLabelMap: any = {
  'child_und_5' : { label:  "Children under 5",
     visible: true,
   },
   'chd__05' : { label:  "Children under 5",
     visible: true,
   },
   'chld__5' : { label:  "Children under 5",
     visible: true,
   },
   'chl__01' : { label:  "Children under 1",
     visible: true,
   },
   'lv_brth' : { label:  "Live Births",
     visible: true,
   },
  'elderly' : { label:  "Persons over 60",
     visible: true,
   },
  'total_pop' : { label:  "Total Population",
     visible: true,
   },
   'ttl_ppl' : { label:  "Total Population",
     visible: true,
   },
   'totl_pp' : { label:  "Total Population",
     visible: true,
   },
   'tot_pop' : { label:  "Total Population",
     visible: true,
   },
  'women_repro' : { label:  "Woman of Childbearing Age",
     visible: true,
   },
   'wmn_rpr' : { label:  "Woman of Childbearing Age",
     visible: true,
   },
   'lg_wmn_' : { visible: false, label: ""},
   'lg_ldrl' : { visible: false, label: ""},
   'lg_c__5' : { visible: false, label: ""},
   'lg_ttl_' : { visible: false, label: ""},
   'wmn_chl' : { label:  "Woman of Childbearing Age",
     visible: true,
   },
   'microplan' : { label: "Microplan",
     visible: false,
   },
   'block_id' : { label: 'Microplan Number',
     visible: false
   },
   'Site_ID' : {
     label: 'Site ID',
     visible: false
   },
   //This block was created for Haiti
   'crssct_' : {
     label: "CrossCut ID",
     visible: true
   },
   'Submttr' : {
     label: 'Submitter',
     visible: true
   },
   'Shortcd' : {
     label: 'Short code',
     visible: false
   },
   'RspnsID' : {
     label: 'Site_ID',
     visible: false
   },
   'Form' : {
     label: 'Facility Type',
     visible: true
   },
   'GropLvl' : {
     label: 'Group Level',
     visible: false
   },
   'Reviewd' : {
     label: 'Reviewed',
     visible: false
   },
   'GPSAltt' : {
     label: 'GPS Altitude',
     visible: true
   },
   'GPSAccr' : { label: 'GPS Accuracy', visible: true },
   'Localty' : { label: 'Facility Name', visible: true },
   'LctnOsD' : { label: 'Admin1', visible: true },
   'LctnOsC' : { label: 'Commune', visible: true },
   'LctOS_C' : { label: 'Commune', visible: true }, //Duplicates?
   'LctnOSC_1' : { label: 'Section Communal', visible: true },
   'LctnOsL' : { label: 'Locality', visible: true },
   'NameLdr' : { label: 'Leader', visible: true },
   'Notes' : { label: 'Notes', visible: true }
}







export const populationFieldLookup = (key: string) => {
  return microplanLabelMap[key] || {
    label: key,
    id: key,
    visible: false
  }
}



export const siteLabelMap: any = {
  'Region' : {
    visible: true,
    label: "Administrative Unit Name",
  },
  'Site_Categ' : {
    visible: true,
    label: "Facility Type"
  },
  'Public_Pri' : {
    visible: true,
    label: 'Ownership'
  },
  'GPS_Point' : {
    visible: true,
    label: 'GPS Coordinates'
  },
  'Data_Colle' : {
    visible: true,
    label: 'Coordinates Source'
  }
}